window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

require('./web_function')

$(function () {

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'mission':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-1", offsetY: 0 } });
                break;

            case 'vision':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-2", offsetY: 0 } });
                break;

            case 'company-history':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;

            case 'management-team':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-4", offsetY: 0 } });
                break;

            case 'board-of-directors':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-5", offsetY: 0 } });
                break;

            case 'strategic-advisors':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-6", offsetY: 0 } });
                break;

            case 'global-operations':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-7", offsetY: 0 } });
                break;
        }
    }

    $('.rd-change-area').on('click', function () {
        $('.rd-change-area').removeClass('now').eq($(this).index()).addClass('now')
        $('.rd-block').fadeOut().eq($(this).index()).fadeIn()
    })

    $('#rd-change-area-1').on('click', function () {
        $('.org_mb1').fadeIn()
        $('.yel_mb1').fadeOut()
        $('.ge_mb1').fadeOut()
    })

    $('#rd-change-area-2').on('click', function () {
        $('.org_mb1').fadeOut()
        $('.yel_mb1').fadeIn()
        $('.ge_mb1').fadeOut()
    })

    $('#rd-change-area-3').on('click', function () {
        $('.org_mb1').fadeOut()
        $('.yel_mb1').fadeOut()
        $('.ge_mb1').fadeIn()
    })

    $('.rd-more-1').on('click', function () {
        $('#rd-more-box-1').fadeIn()
    })

    $('.rd-more-2').on('click', function () {
        $('#rd-more-box-2').fadeIn()
    })

    $('.rd-more-3').on('click', function () {
        $('#rd-more-box-3').fadeIn()
    })

    $('.rd-close-more').on('click', function () {
        $('#rd-more-box-1').fadeOut()
        $('#rd-more-box-2').fadeOut()
        $('#rd-more-box-3').fadeOut()
    })

    changeLogoColor()
})

function changeLogoColor() {

    ScrollTrigger.create({
        trigger: "#rd-section-7",
        start: "top top",
        markers:false,
        onEnter: function () {
            switchHeaderBlue(false)
        },
        onEnterBack: function () {
            switchHeaderBlue(false)
        },
        onLeave: function () {
            switchHeaderBlue(true)
        },
        onLeaveBack: function () {
            switchHeaderBlue(true)
        }
    });

}
